import { HttpParams } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular/standalone';
import { Customer } from 'src/app/interfaces/customer';
import { Project } from 'src/app/interfaces/project';
import { DeviceService } from 'src/app/services/device.service';
import { ProjectService } from 'src/app/services/project.service';
import { LoaderComponent } from '../../../../components/loader/loader.component';
import { SearchItemComponent } from '../../../../components/search-item/search-item.component';
import { NgIf, NgFor } from '@angular/common';
import {
  IonInfiniteScroll,
  IonInfiniteScrollContent,
} from '@ionic/angular/standalone';

@Component({
  selector: 'app-organisation-projects',
  templateUrl: './organisation-projects.component.html',
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    SearchItemComponent,
    LoaderComponent,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
  ],
})
export class OrganisationProjectsComponent implements OnInit {
  @Input() customer: Customer;

  public projects: Project[];
  public totalProjects = 0;
  public projectsLoaded = false;
  public perPage = 7;
  public page = 1;
  public deviceDataLoaded = false;

  constructor(
    private projectService: ProjectService,
    private platform: Platform,
    private deviceService: DeviceService
  ) {}

  async ngOnInit() {
    if (this.platform.is('desktop')) this.perPage *= 3;
    await this.loadProjects();
  }

  private async loadProjects() {
    const params = new HttpParams()
      .set('customer', this.customer.id)
      .set('page', this.page)
      .set('perPage', this.perPage);

    try {
      const response = await this.projectService.getAllProjects(params);
      const projects = await this.loadDeviceData(response.member);
      this.totalProjects = response.totalItems;
      this.projects =
        this.page === 1 ? projects : this.projects.concat(projects);
      this.page++;
      this.projectsLoaded = true;
    } catch (error) {
      // ignore
    }
  }

  private async loadDeviceData(projects: Project[]): Promise<Project[]> {
    let projectIds = projects.map(({ id }) => id);

    try {
      const response = await this.deviceService.getData(
        new HttpParams().set('project_ids', projectIds.join(','))
      );
      projects = projects.map((project) => {
        project.starred = response.projects[project.id].starred;
        project.distance = response.projects[project.id].distance;
        return project;
      });
      this.deviceDataLoaded = true;
      return projects;
    } catch (error) {}
    return null;
  }
}
